import { render, staticRenderFns } from "./crear-colaborador.vue?vue&type=template&id=2ec90f2a&scoped=true&"
import script from "./crear-colaborador.vue?vue&type=script&lang=js&"
export * from "./crear-colaborador.vue?vue&type=script&lang=js&"
import style0 from "./crear-colaborador.vue?vue&type=style&index=0&id=2ec90f2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec90f2a",
  null
  
)

export default component.exports